import { createFileRoute, redirect } from '@tanstack/react-router'

import { WorkflowRoute } from '@/app/routes/_app/workflows/workflows'
import { getUserInfo } from '@/features/auth'
import { ForgotPasswordPage } from '@/pages/forgot-password'

export const Route = createFileRoute('/forgot-password')({
  component: RouteComponent,
  loader: async () => {
    try {
      const userInfo = await getUserInfo()
      if (userInfo) return redirect({ to: WorkflowRoute.to })
    } catch {
      // 🏡 stay on the page
    }
  },
})

export const ForgotPasswordRoute = Route

function RouteComponent() {
  return <ForgotPasswordPage />
}
